export default "__VITE_ASSET__BPatbddb__"